// Messages
export const CONFIRM_DELETE = 'Are you sure you want to delete '

// Types
export const DOCUMENT = 'DOCUMENT'
export const PLAYLIST = 'PLAYLIST'
export const QUIZ = 'QUIZ'
export const VIDEO = 'VIDEO'
